export const isHex = (value) => {
  if (typeof value !== "string") {
    return false; 
  }

  const colorHexRegex = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
  return colorHexRegex.test(value);
}

export const formatDate = (dateString) => {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear());
      return `${day}/${month}/${year}`;
}

// export const containsQuery = (query, text) => {
//     if(!text || !query || text === "" || query === ""){
//       return false
//     }

//     return text.toLowerCase().includes(query);
// }

export const containsQuery = (query, text) => {
    if(!text || !query || text === "" || query === ""){
      return text || "-"
    }

    const sanitized_query = query.replace(/[.*+?^=!:${}()|\[\]\/\\]/g, "\\$&");
    const regex = new RegExp(`(${sanitized_query})`, "gi"); 
    return text.replace(regex, `<b className="highlight">$1</b>`);
}